import React, {useState} from 'react'
import {Modal, Form, Input, Checkbox} from 'antd'
import {fromGlobalId} from 'lib/util'
import Button from 'components/shared/Button'

// Base64 of 'InvoiceRecipient:other'
const INVOICE_RECIPIENT_OTHER_ID = 'SW52b2ljZVJlY2lwaWVudDpvdGhlcg=='

function OtherInvoiceRecipientForm({form, handleSubmit, invoiceRecipient}) {
  return (
    <Form form={form} layout="vertical" initialValues={{
      ...invoiceRecipient,
      business: invoiceRecipient.recipientType === 'business'
    }} onFinish={handleSubmit}>
      <Form.Item
        name="business"
        valuePropName="checked"
        shouldUpdate
      >
        <Checkbox>Organisasjon</Checkbox>
      </Form.Item>
      <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.business !== curValues.business}>
        {() => form.getFieldValue('business') && (
            <Form.Item
            name="organizationNumber"
            colon={false}
            label="Organisasjonsnummer"
            rules={[
              { len: 9, message: "Skriv inn gyldig organisasjonsnummer" },
              { required: true, message: "Skriv inn organisasjonsnummer" },
            ]}
            >
            <Input />
          </Form.Item>
          )
        }
      </Form.Item>
        
      <Form.Item
        name="name"
        colon={false}
        label="Mottakernavn"
        rules={[
          {required: true, message: 'Skriv inn gyldig navn'},
          {pattern: /[^\s|-]+\s+[^\s|-]+/, message: 'Skriv inn fullt navn'},
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="streetAddress"
        colon={false}
        label="Gateadresse"
        rules={[{required: true, message: 'Skriv inn gyldig gateadresse'}]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="email"
        colon={false}
        label="E-postadresse"
        rules={[
          {required: true, message: 'Skriv inn gyldig e-post'},
          {type: 'email', message: 'Skriv inn gyldig e-post'},
        ]}
      >
        <Input />
      </Form.Item>

      <div className="postal-fields">
        <Form.Item
          name="postalCode"
          colon={false}
          label="Postnr"
          rules={[{required: true, message: 'Skriv inn gyldig postnr.'}]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="postalArea"
          colon={false}
          label="Poststed"
          rules={[{required: true, message: 'Skriv inn gyldig poststed'}]}
        >
          <Input />
        </Form.Item>
      </div>
    </Form>
  )
}

function SetInvoiceRecipient({invoiceRecipient, onChange, invoiceRecipientAlternatives}) {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [useOtherInvoiceRecipient, setUseOtherInvoiceRecipient] = useState(invoiceRecipientRole(invoiceRecipient) === 'other')
  const [otherInvoiceRecipientForm] = Form.useForm()

  const openModal = () => setModalIsOpen(true)
  const closeModal = () => setModalIsOpen(false)

  const cancelOtherInvoiceRecipient = () => {
    setUseOtherInvoiceRecipient(false)
  }

  function setInvoiceRecipient(invoiceRecipient) {
    closeModal()
    onChange(invoiceRecipient)
  }

  function submitOtherInvoiceRecipient(e) {
    otherInvoiceRecipientForm.validateFields()
      .then(values => {
        setInvoiceRecipient({...values, id: INVOICE_RECIPIENT_OTHER_ID, recipientType: values.business ? 'business' : 'consumer'})
      })
  }

  function invoiceRecipientRole (recipient) {
    return recipient && fromGlobalId(recipient.id).id
  }

  function getRecipientLabel(recipient) {
    const role = invoiceRecipientRole(recipient)
    return {
      customer: 'meglerkontor',
      estate_seller: 'oppdragsadresse',
      other: 'annen',
    }[role]
  }

  return (
    <>
      <Button
        onClick={openModal}
      >
        Bytt mottaker
      </Button>

      <Modal
        title="Velg fakturamottaker"
        visible={modalIsOpen}
        onOk={closeModal}
        onCancel={closeModal}
        footer={
          useOtherInvoiceRecipient
            ? [
              <Button key="cancel" onClick={cancelOtherInvoiceRecipient}>
                Avbryt
              </Button>,
              <Button
                key="other"
                onClick={submitOtherInvoiceRecipient}
              >
                OK
              </Button>,
            ]
            : [
              <Button key="cancel" onClick={closeModal}>
                Avbryt
              </Button>,
              <Button key="other" onClick={() => setUseOtherInvoiceRecipient(true)}>
                Annen fakturamottaker
              </Button>,
            ]
        }
      >
        {useOtherInvoiceRecipient && (
          <div className="invoice-recipient-other">
            <OtherInvoiceRecipientForm
              form={otherInvoiceRecipientForm}
              invoiceRecipient={invoiceRecipientRole(invoiceRecipient) === 'other' ? invoiceRecipient : {}}
              handleSubmit={submitOtherInvoiceRecipient}
            />
          </div>
        )}

        {!useOtherInvoiceRecipient && (
          <div className="invoice-recipient-alternatives">
            {invoiceRecipientAlternatives.map((recipient) => (
              <div
                key={recipient.id}
                className="invoice-recipient-alternative"
                onClick={() => {
                  setInvoiceRecipient(recipient)
                }}
              >
                {recipient.recipientType === 'business' && (
                  <span className="business">
                    {recipient.organizationNumber}
                  </span>
                )}
                <span className="name">
                  {recipient.name} ({getRecipientLabel(recipient)})
                </span>
                <span className="address">
                  {recipient.streetAddress}
                  <br />
                  {recipient.postalCode} {recipient.postalArea}
                </span>
                {!!recipient.email && (
                  <span className="email">
                    E-post: {recipient.email}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </Modal>
    </>
  )
}

export default SetInvoiceRecipient
